export { default } from '@/components/pages/directories/CitiesBySegmentAndState/CitiesBySegmentAndStateDirectory';
export { citiesBySegmentAndStatePageData as getServerSideProps } from '@/components/pages/directories/CitiesBySegmentAndState/citiesBySegmentAndStateDirectoryProps';
